// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/loteria/modalidade/modalidade.css
// module id = 360
// module chunks = 0